<template>
  <div class="customerOrderDetailPage">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane
        :label="$l('tab_base_information') || '基本信息'"
        name="tcOrderInfo"
      >
        <TcOrderInfo
          ref="base"
          :tcOrderCode="params.code"
          :disabled="disabled"
        />
        <div class="d-flex justify-content-end mt-2 mb-2" v-if="!disabled">
          <el-button type="primary" size="small" @click="$refs.base.save()">
            {{ $l('INDEX.btn_save') || '保存' }}
          </el-button>
        </div>
      </el-tab-pane>
      <el-tab-pane
        :label="$l('tab_tc_order_goods') || '产品信息'"
        name="tcOrderGoods"
        lazy
      >
        <TcOrderGoods :tcOrderCode="params.code" :disabled="disabled" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import TcOrderInfo from '../components/order-info'
import TcOrderGoods from '../components/order-goods'
export default {
  name: 'tc-scmOrder-detail',
  components: { TcOrderInfo, TcOrderGoods },
  data() {
    return { activeName: 'tcOrderInfo' }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return this.pageType === 'detail'
    },
  },
}
</script>
